module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.d4da09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_hero.png
// module id = 492s
// module chunks = 0